import React from "react";

const ExpertiseSection: React.FC = () => {
  return (
    <section className="expertise-wrapper" id="expertise">
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">Architectural Expertise</h2>
          <p className="section-subtitle">
            Practical, battle-tested experience designing, building, and running
            modern cloud-native and AI-powered systems.
          </p>
        </div>

        <div className="pill-grid">
          <div className="pill-column">
            <h3 className="pill-heading">Cloud &amp; Microservices</h3>
            <ul className="pill-list">
              <li>AWS (EKS, ECS Fargate, Lambda)</li>
              <li>VPC design, private networking, ALB/NLB</li>
              <li>SQS, SNS, EventBridge for async workflows</li>
              <li>RDS (Postgres), DynamoDB, Redis</li>
              <li>Kafka/MSK and streaming pipelines</li>
              <li>Circuit breaker, bulkhead, retry/backoff, timeouts</li>
              <li>Strangler-fig migration and legacy modernization</li>
            </ul>
          </div>

          <div className="pill-column">
            <h3 className="pill-heading">Solution Architecture</h3>
            <ul className="pill-list">
              <li>Domain-Driven Design (DDD), Hexagonal, Clean Architecture</li>
              <li>Event Sourcing, CQRS, SAGA orchestration patterns</li>
              <li>
                API Gateway / BFF, multi-tenant and bounded-context design
              </li>
              <li>Architecture decision records (ADR) and design reviews</li>
            </ul>
          </div>

          <div className="pill-column">
            <h3 className="pill-heading">Experience &amp; Delivery</h3>
            <ul className="pill-list">
              <li>Ultra-fast SPA &amp; dashboard UX (React, Angular)</li>
              <li>CDN, caching, and front-end performance optimization</li>
              <li>Blue/green and canary releases, feature flags</li>
              <li>
                End-to-end delivery of scalable, low-latency, resilient systems
              </li>
            </ul>
          </div>

          <div className="pill-column">
            <h3 className="pill-heading">Reliability &amp; Observability</h3>
            <ul className="pill-list">
              <li>New Relic, Splunk, Datadog, Prometheus</li>
              <li>Distributed tracing &amp; log pipelines</li>
              <li>Dashboards, alerting, SLOs/SLIs</li>
              <li>Incident response &amp; performance tuning</li>
            </ul>
          </div>

          <div className="pill-column">
            <h3 className="pill-heading">Generative AI &amp; Data</h3>
            <ul className="pill-list">
              <li>RAG architectures &amp; vector search</li>
              <li>AWS Bedrock, OpenAI, Llama models</li>
              <li>LLM prompt and prompt-chain design</li>
              <li>AI-powered analytics &amp; decision support</li>
              <li>Data lakes and warehouses (S3, Redshift)</li>
            </ul>
          </div>

          <div className="pill-column">
            <h3 className="pill-heading">Engineering &amp; Delivery</h3>
            <ul className="pill-list">
              <li>Java 17+, Spring Boot 3+, Spring Security</li>
              <li>Node.js, NestJS, Express APIs</li>
              <li>React &amp; TypeScript SPA/front-end architecture</li>
              <li>Terraform, AWS CDK, Docker, GitOps</li>
              <li>CI/CD with GitLab, GitHub Actions, Jenkins</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExpertiseSection;
